export function maxBy<T>(items: T[], getValue: (elem: T) => number): T | undefined {
    if (items.length === 0) {
        return undefined;
    }
    return items.reduce((max, item) => (getValue(item) > getValue(max) ? item : max), items[0]);
}
